<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">Error/Bug Log List</p>
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-user"
            placeholder="Id"
            icon-no-border
            label="Id"
            v-model="input13"
          />
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-mail"
            placeholder="Email"
            icon-no-border
            label="Email"
            v-model="input13"
          />
        </div>
        <div class="vx-col">
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon="icon-feather"
            placeholder="Classes"
            icon-no-border
            label="Classes"
            v-model="input13"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button color="success" class="mr-3 mb-2">Search</vs-button>
          <vs-button color="danger" class="mb-2 mr-3">Reset</vs-button>
          <vs-button color="black" class="mb-2" @click="data_hide = !data_hide"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table max-items="10" stripe :data="users">
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Date</vs-th>
          <vs-th>Time</vs-th>
          <vs-th>OS Type</vs-th>
          <vs-th>App Version</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].created_at">
              {{ data[indextr].created_at | formatDate }}
            </vs-td>

            <vs-td :data="data[indextr].created_at">
              {{ data[indextr].created_at | formatTime }}
            </vs-td>

            <vs-td :data="data[indextr].os_type">
              <div v-if="data[indextr].device_type">
                <p class="approveda" v-if="data[indextr].device_type == 'A'">
                  {{ $t("labels.android") }}
                </p>
                <p class="rejecteda" v-if="data[indextr].device_type == 'I'">
                  {{ $t("labels.Ios") }}
                </p>
              </div>
            </vs-td>

            <vs-td :data="data[indextr].app_version">
              {{ data[indextr].app_version }}
            </vs-td>

            <vs-td :data="data[indextr].email">
              <span>
                <router-link
                  :to="{ name: 'BugById', params: { id: data[indextr].id } }"
                >
                  <vs-button
                    title="View"
                    size="small"
                    class="m-1 float-left"
                    color="success"
                    icon="icon-eye"
                    icon-pack="feather"
                  ></vs-button>
                </router-link>

                <vs-button
                  title="Delete"
                  size="small"
                  class="m-1 float-left"
                  color="danger"
                  icon="icon-trash-2"
                  @click="DeleteBug()"
                  icon-pack="feather"
                ></vs-button>
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div style="height: 50px">
      <div class="float-left mt-5">
        <vs-pagination
          ref="paginationContact"
          :total="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    question: "",
    answer: "",
    classes: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllException();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllException();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllException();
      }
    },
  },
  methods: {
    getAllException() {
      let input = {
        title: this.title,
        page: this.currentPage,
        perPage: this.perPage,
      };
      axios
        .post("admin/allException", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.exceptions;
          this.totalPage = Math.ceil(data.count / this.perPage);
          let page = this.$route.query.page;
          if (page) {
            this.currentPage = page;
          }
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.question = ""), (this.answer = "");
    },
    BlockUnblock(id, status) {
      this.changeID = id;
      this.sts = status;
      let text = text;
      let title_model = title_model;
      if (status) {
        text = this.$t("strings.deactivate_faq");
        title_model = this.$t("labels.deactivate_faq");
      } else {
        text = this.$t("strings.activate_faq");
        title_model = this.$t("labels.activate_faq");
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: title_model,
        text: text,
        acceptText: this.$t("labels.delete_button"),
        accept: this.acceptAlert,
      });
    },
    acceptAlert() {
      let input = {
        is_active: !this.sts,
      };
      axios
        .post("faq/changeStatus/" + this.changeID, input)
        .then((response) => {
          let data = response.data;

          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllException();
          this.changeID = null;
        })
        .catch((e) => {
          this.changeID = null;
          this.showError(e);
        });
    },
    DeleteBug(id) {
      this.deleteID = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("labels.delete_bug"),
        text: this.$t("strings.delete_bug"),
        acceptText: this.$t("labels.delete_button"),
        accept: this.deleteUser,
      });
    },
    deleteUser() {
      let input = {
        faq_id: this.deleteID,
      };
      axios
        .get("faq/delete/" + this.deleteID)
        .then((response) => {
          let data = response.data;
          this.getAllException();
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });

          this.deleteID = null;
        })
        .catch((e) => {
          this.deleteID = null;
          this.showError(e);
        });
    },
    addFaq() {
      let input = {
        code: this.question,
        answer: this.answer,
      };
      axios
        .post("faq/addFaq", input)
        .then((response) => {
          let data = response.data;
          this.resetForm();
          this.data_hide = true;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
          this.getAllException();
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },
  mounted() {
    this.getAllException();
  },
};
</script>

<style lang="scss" scoped>
</style>